<template>
  <header class="app-navbar">
    <div class="app-navbar__inner">
      <div class="app-navbar__left">
        <router-link :to="{ name: 'home' }" class="app-navbar__logo">
          <img src="../assets/images/idlogo.png" alt="ImpactPilot" />
        </router-link>

        <nav class="app-navbar__pills">
          <router-link
            v-for="item in navItems"
            :key="item.name"
            :to="{ name: item.name }"
            class="app-navbar__pill"
            :class="{ 'app-navbar__pill--active': isPillActive(item) }">
            {{ item.label }}
          </router-link>
        </nav>
      </div>

      <div class="app-navbar__right">
        <button type="button" class="app-navbar__ask-ai" @click="handleAskAi">
          <StarIcon :size="20" />
          <span>Ask AI</span>
        </button>

        <div class="dropdown app-navbar__user">
          <button
            type="button"
            class="app-navbar__icon-btn"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-label="Open menu">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#766681"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"></circle>
              <path
                d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
          </button>
          <div
            class="dropdown-menu dropdown-menu-end app-navbar__menu"
            style="z-index: 100">
            <a href="/settings" class="dropdown-item ai-icon" v-if="isAdmin">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="feather feather-settings text-primary"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="3"></circle>
                <path
                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </svg>
              <span class="ms-2">Settings</span>
            </a>
            <a href="/notifications" class="dropdown-item ai-icon">
              <i
                class="la la-envelope"
                style="
                  font-size: 18px;
                  color: var(--primary);
                  vertical-align: middle;
                "></i>
              <span class="ms-2">Notifications</span>
            </a>
            <a href="/logout" class="dropdown-item ai-icon">
              <svg
                id="icon-logout"
                xmlns="http://www.w3.org/2000/svg"
                class="text-danger"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span class="ms-2">Logout</span>
            </a>
          </div>
        </div>

        <div
          class="app-navbar__avatar"
          :class="{
            'app-navbar__avatar--impersonated': userData?.impersonated,
          }"
          :title="`${userData.firstname} ${userData.lastname}`">
          <span v-if="userData?.impersonated" class="app-navbar__crown">
            👑
          </span>
          <span class="app-navbar__initials">{{ initials }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { useRouter } from "vue-router";
import { isFeatureEnabled } from "@/src/assets/js/impactdriver_front/requests";
import { useMainStore } from "@/src/stores/main";
import StarIcon from "./icons/StarIcon.vue";

export default {
  components: { StarIcon },
  inheritAttrs: false,
  props: { userData: { type: Object, default: null } },
  data() {
    return {
      signalsEnabled: false,
      processesEnabled: false,
      impactDriversEnabled: false,
    };
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  computed: {
    isAdmin() {
      return this.userData?.roles?.includes("ROLE_ADMIN");
    },
    initials() {
      return (
        this.userData.firstname[0] + this.userData.lastname[0]
      ).toUpperCase();
    },
    navItems() {
      const items = [
        { name: "home", label: "Accounts" },
        { name: "dashboard", label: "Dashboard" },
      ];
      if (this.impactDriversEnabled) {
        items.push({ name: "account_planning", label: "Account planning" });
      }
      items.push({
        name: "charts",
        label: "Trend Builder",
        extra: ["view_chart"],
      });
      if (this.impactDriversEnabled) {
        items.push({ name: "report", label: "Report" });
      }
      if (this.processesEnabled) {
        items.push({
          name: "processes",
          label: "Processes",
          extra: ["process_builder"],
        });
      }
      if (this.signalsEnabled) {
        items.push({ name: "signals", label: "Signals" });
      }
      return items;
    },
  },
  methods: {
    isPillActive(item) {
      const current = this.router.currentRoute.value.name;
      if (current === item.name) return true;
      return item.extra?.includes(current) ?? false;
    },
    handleAskAi() {
      useMainStore().toggleAiChat();
    },
  },
  async mounted() {
    this.signalsEnabled = await isFeatureEnabled("signals_enabled");
    this.processesEnabled = await isFeatureEnabled("processes");
    const flags = await useMainStore().ensureFeatureFlags();
    this.impactDriversEnabled = !flags.impactDriversDisabled;
  },
};
</script>
